import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { Badge } from "@/ui/badge";

import { useUserPreferencesNotificationsContext } from "../user-preferences-notifications.context";
import { getSettingsDiffCount } from "../user-preferences-notifications.helper";

import "./user-preferences-notifications-status.style.less";

const { Text } = Typography;

export const UserPreferencesNotificationsStatus = () => {
  const { t } = useTranslation();
  const { savedSettings, unsavedSettings } =
    useUserPreferencesNotificationsContext();

  const unsavedCount = getSettingsDiffCount(savedSettings, unsavedSettings);

  if (!unsavedCount) return null;

  return (
    <Flex gap="small" className="user-preferences-notifications-status">
      <Badge status="info" />
      <Text>
        {t("user:preferences.notifications.unsavedCount", {
          count: unsavedCount,
        })}
      </Text>
    </Flex>
  );
};
